// EmailJS Configuration
// Get your credentials from https://www.emailjs.com/

export const EMAILJS_CONFIG = {
  // Your EmailJS Service ID
  SERVICE_ID: 'service_yusxx9m',

  // Your EmailJS Public Key (User ID)
  PUBLIC_KEY: 'A4IhI_K6iOCQeZU1e',

  // Template IDs
  TEMPLATES: {
    AGENT_FORM: 'template_fo2kdlk',
    CUSTOMER_FORM: 'template_fo2kdlk',
    CONTACT_FORM: 'template_fo2kdlk', // Using same template for contact form
  }
};

// Instructions:
// 1. Sign up at https://www.emailjs.com/
// 2. Add an email service (Gmail, Outlook, etc.)
// 3. Create email templates for both forms
// 4. Replace the placeholder values above with your actual credentials
// 5. DO NOT commit this file with real credentials to public repositories
